import { ActionReducerMap, createFeatureSelector } from "@ngrx/store";
import { CoreState } from "@core/models";
import { reducer as sessionReducer } from "@core/store/reducers/session.reducer";
import { routerReducer } from "@ngrx/router-store";

export const reducers: ActionReducerMap<CoreState> = {
  session: sessionReducer,
  router: routerReducer
};

export const selectCoreState = createFeatureSelector<CoreState>("core");

export * from "./custom-serializer";
